import React, { useState } from 'react';
import '../assets/css/style.css';

const HtmlGameLaunchWindow = ({ url }) => {
  const [loading, setLoading] = useState(true);
  const handleIframeLoad = () => {
    // Set loading to false when the iframe content has finished loading
    setLoading(false);
  };

  return (
    <div style={iframeContainerStyle}>
      {loading && (
        <div style={loaderContainerStyle}>
          <span>Loading</span>
          <span style={dotStyle}>.</span>
          <span style={dotStyle}>.</span>
          <span style={dotStyle}>.</span>
        </div>
      )}
        <iframe
          srcDoc={url}
          title="Game Launch Window"
          style={iframeStyle}
          frameBorder="0"
          allowFullScreen
          onLoad={handleIframeLoad}
        />

    </div>
  );
};

const iframeContainerStyle = {
  position: 'relative',
  width: '100%',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const loaderContainerStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'center',
  fontSize: '2rem', /* Increased font size */
  color: '#2d2d2d', /* Blue color for the text */
  fontFamily: 'Arial, sans-serif', /* Clean font */
  letterSpacing: '0.1em', /* Add some space between letters */
};

const dotStyle = {
  animation: 'dotFlashing 1.5s infinite steps(1, end) both',
  marginLeft: '5px', /* Spacing between dots */
  fontSize: '2rem', /* Same size as text */
  color: '#2d2d2d', /* Blue color for dots */
};

const iframeStyle = {
  width: '100%',
  height: '100%',
};

export default HtmlGameLaunchWindow;